/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2024-12-03 16:22:32
 * @FilePath: \client-h5\src\pages\waterUseRecord\services.js
 */
import http from '../../utils/http';

export function getBilldetail(params) {
  return http("get", '/order/cardSelfServiceMachine/account/bill/detail',params);
}
export function getBilldetailGzh(params) {
  return http("get", '/order/guardian/query/account/bill/detail',params,true);
}
export function payGzh(params) {
  return http("post", '/order/guardian/thirdTrade/single/json/pay',params,true);
}
export function pay(params) {
  return http("post", '/order/thirdTrade/single/json/pay',params);
}
export function complain(params) {
  return http("get", '/workorder/v3/complain/bill/list',params);
}